import React, { useState, useEffect } from 'react';
import { Badge, Calendar, Select, Row, Col, Popover, message, notification as NotifcationUI } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
import { AtbdTopDropdwon } from './auth-info-style';
import { CalendarIcon } from '../../Icons/Icons';
import { getSocket } from "../../../Api/Socket";
import { caldrSuccess } from '../../../redux/CrmReduxCalls/CalendarResponse';
import { CalendarWrapper1 } from '../../../container/dashboard/calendar/Style'
import 'react-calendar/dist/Calendar.css';
import Popup from '../../../container/dashboard/Popup/CalendarMeetingpopup'
import { FetchAllRecentMeetings } from '../../../Api/Services/MeetingApiService';

const notificationIdsShown = new Set();

function Calendars() {
    const dispatch = useDispatch();
    const edit = useSelector((state) => state.edit.edit);
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const storeSubcription = localData.subcription
    const { apiValues } = useSelector((state) => state.CalendarRData);
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const [meetingData, setMeetingData] = useState([])
    const [modelOpen, setModelOpen] = useState(false)
    const [mObject, setMObject] = useState()
    const [open, setOpen] = useState(false);
    const [state, setState] = useState({
        value: moment(),
        selectedValue: moment(),
    });
    const iconWrapper = {
        width: 36,
        height: 36,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        color: '#407fe9',
        backgroundColor: "#407fe915",
    };
    const OutLookDateTimeForTimeZone = (dateTime) => {
        const DateTime = `${dateTime.replace(/\.\d+/, "")}.000Z`;
        const formatedDateTime = moment(DateTime, "YYYY-MM-DDTHH:mm:ss.Z").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    const ZohoDateTimeForTimeZone = (dateTime) => {
        const formatedDateTime = moment(dateTime, "YYYYMMDDTHHmmssZ").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    function convertTimeZoneAndFormat(dateTimeStr, profileTimeZone) {
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profileTimeZone.timeZone);
        const utcMoment = moment.parseZone(dateTimeStr).utc();
        const targetMoment = utcMoment.clone().tz(toTimezone);
        return {
            date: targetMoment.format('MM/DD/YYYY'),
            time: targetMoment.format('h:mm a')
        };
    }
    function convertTimeZoneAndFormat1(dateTimeStr, profileTimeZone) {
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profileTimeZone.timeZone);
        const utcTime = moment.utc(dateTimeStr);
        const targetMoment = utcTime.clone().tz(toTimezone);
        return {
            date: targetMoment.format('MM/DD/YYYY'),
            time: targetMoment.format('h:mm a')
        };
    }
    const DetailsOpen = (value, data) => {
        if (storeSubcription?.isActive) {
            setModelOpen(value)
            setMObject(data)
            setOpen(false);
        } else {
            message.info("Your subscription is not active. Please renew to continue");
        }
    };
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    const transformMeetingsData = (meetings) => {
        return meetings.map(meeting => {
            const { id, summary, subject, start, end, creator, responseStatus, dateandtime, title, uid, organizer, status, isCancelled } = meeting;
            let formattedFromDate;
            let formattedFromTime;
            let formattedToDate;
            let formattedToTime;
            if (emailapiValues?.emailType === "Google") {
                const from = convertTimeZoneAndFormat(start.dateTime, profile);
                const to = convertTimeZoneAndFormat(end.dateTime, profile);
                formattedFromDate = from.date;
                formattedFromTime = from.time;
                formattedToDate = to.date;
                formattedToTime = to.time;
            }
            else if (emailapiValues?.emailType === "Outlook") {
                const startFrom = OutLookDateTimeForTimeZone(start.dateTime)
                const endTo = OutLookDateTimeForTimeZone(end.dateTime)
                const from = convertTimeZoneAndFormat1(startFrom, profile);
                const to = convertTimeZoneAndFormat1(endTo, profile);
                formattedFromDate = from.date;
                formattedFromTime = from.time;
                formattedToDate = to.date;
                formattedToTime = to.time;
            }
            else if (emailapiValues?.emailType === "Zoho") {
                const startFrom = ZohoDateTimeForTimeZone(dateandtime?.start)
                const endTo = ZohoDateTimeForTimeZone(dateandtime?.end)
                const from = convertTimeZoneAndFormat1(startFrom, profile);
                const to = convertTimeZoneAndFormat1(endTo, profile);
                formattedFromDate = from.date;
                formattedFromTime = from.time;
                formattedToDate = to.date;
                formattedToTime = to.time;
            }
            return {
                title: emailapiValues?.emailType === "Google" ?
                    summary && summary !== "" ? summary : "No Subject"
                    : emailapiValues?.emailType === "Outlook" ?
                        subject && subject !== "" ? subject : "No Subject"
                        : emailapiValues?.emailType === "Zoho" ?
                            title && title !== "" ? title : "No Subject"
                            : summary && summary !== "" ? summary : "No Subject",
                date: [formattedFromDate, formattedToDate],
                id: emailapiValues?.emailType === "Zoho" ? uid : id,
                meetingOn: emailapiValues?.emailType === "Google" ? status
                    : emailapiValues?.emailType === "Outlook" ? (isCancelled ? "removed" : "confirmed")
                        : emailapiValues?.emailType === "Zoho" ? "confirmed" : "confirmed",
                // creator: emailapiValues?.emailType === "Google" ? creator 
                creator: emailapiValues?.emailType === "Google" ? organizer
                    : emailapiValues?.emailType === "Outlook" ? responseStatus
                        : emailapiValues?.emailType === "Zoho" ? organizer
                            : creator,
                time: [formattedFromTime, formattedToTime],
            };
        });
    };
    async function GetAll(StartDate, EndDate) {
        try {
            const response = await FetchAllRecentMeetings(StartDate, EndDate)
            if (response.data.success === false) {
                dispatch(caldrSuccess("NoCall"))
                // message.error(response.data.message)
                // message.error("Email connection error. Update your settings to restore access")
            } else {
                let FilterMeetings = [];
                if (emailapiValues?.emailType === "Zoho") {
                    FilterMeetings = response.data.events.filter((item) => item.rsvp !== "no")
                }
                if (emailapiValues?.emailType === "Google") {
                    FilterMeetings = response.data.events.filter(meeting => {
                        if (meeting.status === "cancelled") return false;
                        if (meeting.organizer?.self) return true;
                        if (meeting.creator?.self) return true
                        const selfAttendee = meeting.attendees?.find(att => att.self);
                        return selfAttendee && selfAttendee.responseStatus !== "declined";
                    });
                }
                if (emailapiValues?.emailType === "Outlook") {
                    FilterMeetings = response.data.events.filter((item) => item.responseStatus.response !== "declined")
                }
                setMeetingData(transformMeetingsData(FilterMeetings))
                dispatch(caldrSuccess("NoCall"))
            }
        } catch (error) {
            message.error("Email connection error. Update your settings to restore access")
            // message.error(error);
        }
    }
    const onPanelChange = (value) => {
        if (storeSubcription?.isActive) {
            setState({ ...state, value });
        } else {
            message.info("Your subscription is not active. Please renew to continue");
        }
    };
    const headerRender = ({ value, onChange }) => {
        const maxYear = 9000;
        const minYear = 1001;
        const currentYear = value.year();
        const monthOptions = [];
        const yearOptions = [];
        const current = value.clone();
        const localeData = value.localeData();
        const months = [];
        for (let i = 0; i < 12; i += 1) {
            current.month(i);
            months.push(localeData.monthsShort(current));
        }
        for (let i = 0; i < 12; i += 1) {
            monthOptions.push(
                <Select.Option key={i} value={i}>
                    {months[i]}
                </Select.Option>
            );
        }
        for (let i = minYear; i <= maxYear; i += 1) {
            yearOptions.push(
                <Select.Option key={i} value={i}>
                    {i}
                </Select.Option>
            );
        }
        return (
            <div style={{ padding: 8 }}>
                <Row gutter={8}>
                    <Col>
                        <Select
                            value={value.month()}
                            onChange={(newMonth) => {
                                if (storeSubcription?.isActive) {
                                    const now = value.clone().month(newMonth);
                                    onChange(now);
                                    dispatch(caldrSuccess("ApiCall"))
                                    setState({ ...state, value: now });
                                } else {
                                    message.info("Your subscription is not active. Please renew to continue");
                                }
                            }}
                        >
                            {monthOptions}
                        </Select>
                    </Col>
                    <Col>
                        <Select
                            value={currentYear}
                            onChange={(newYear) => {
                                if (storeSubcription?.isActive) {
                                    const now = value.clone().year(newYear);
                                    onChange(now);
                                    dispatch(caldrSuccess("ApiCall"))
                                    setState({ ...state, value: now });
                                } else {
                                    message.info("Your subscription is not active. Please renew to continue");
                                }
                            }}
                            style={{ width: '100px' }}
                        >
                            {yearOptions}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    };
    const getListData = (value) => {
        return meetingData.filter(event => {
            const [startDate, endDate] = event.date;
            const start = moment(startDate, 'MM/DD/YYYY');
            const end = moment(endDate, 'MM/DD/YYYY');
            return value.isBetween(start, end, 'days', '[]');
        });
    };
    const dateCellRender = (value) => {
        const listData = getListData(value);
        return (
            <ul className="events">
                {listData.map((item, index) => (
                    <li key={index} style={{
                        border: "1px solid #9f9f9f",
                        padding: "2px 4px 0px",
                        borderRadius: "10px",
                        marginBottom: 5,
                        fontSize: 12
                    }}>
                        <div title={item.title === "" ? "No Subject" : item.title}
                            role="button"
                            tabIndex={0}
                            onClick={() => DetailsOpen(true, item.id)}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    DetailsOpen(true, item.id)
                                }
                            }}
                        >
                            <Badge className='meeting-badge' color={item.meetingOn === 'removed' ? '#bebebe' : item.meetingOn === 'confirmed' && '#20c997'} text={item.title === "" ? "No Subject" : item.title} style={{ lineHeight: "normal" }} />
                        </div>
                    </li>
                ))
                }
            </ul >
        );
    };
    const content = (
        <AtbdTopDropdwon className="atbd-top-dropdwon" style={{ width: 750, height: 500 }}>
            <Scrollbars style={{ width: 750, height: 500 }}>
                {emailactiontype ? <div style={{ color: "red" }}>
                    * No Configuration found!
                </div> : emailapiValues?.emailType === "Other Email" && <div style={{ color: "red" }}>
                    * Calendar invites are not supported by your email provider!
                </div>}
                <CalendarWrapper1>
                    <Calendar
                        mode="month"
                        headerRender={headerRender}
                        onPanelChange={onPanelChange}
                        value={state.value}
                        dateCellRender={dateCellRender}
                    />
                </CalendarWrapper1>
            </Scrollbars>
        </AtbdTopDropdwon>
    );
    useEffect(() => {
        if (emailapiValues !== "" && !emailactiontype) {
            if (apiValues === "ApiCall") {
                if (emailapiValues?.emailType && (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook")) {
                    const StartDate = moment(state.value).utc().startOf('month').toISOString();
                    const EndDate = moment(state.value).utc().endOf('month').toISOString();
                    GetAll(StartDate, EndDate)
                }
                if (emailapiValues?.emailType && emailapiValues?.emailType === "Zoho" && emailapiValues?.calendarId) {
                    const StartDate = moment(state.value).startOf('month').format('YYYYMMDD')
                    const EndDate = moment(state.value).endOf('month').format('YYYYMMDD')
                    GetAll(StartDate, EndDate)
                }
            }
        }
    }, [emailapiValues, emailactiontype, state, apiValues])
    useEffect(() => {
        const socket = getSocket();
        const handleNotification = (data) => {
            const events = [data]
            let FilterMeetings = [];
            if (emailapiValues?.emailType === "Zoho") {
                FilterMeetings = events.filter((item) => item.rsvp !== "no")
            }
            if (emailapiValues?.emailType === "Google") {
                FilterMeetings = events.filter(meeting => {
                    if (meeting.creator?.self) {
                        return true;
                    }
                    const selfAttendee = meeting.attendees?.find(att => att.self);
                    return selfAttendee && selfAttendee.responseStatus !== "declined";
                });
            }
            if (emailapiValues?.emailType === "Outlook") {
                FilterMeetings = events.filter((item) => item.responseStatus.response !== "declined")
            }
            const newdata = transformMeetingsData(FilterMeetings)
            if (FilterMeetings.length > 0) {
                setMeetingData((prev) => [...prev, ...newdata]);
            }
            dispatch(caldrSuccess("NoCall"))
            if (!notificationIdsShown.has(newdata[0].id)) {
                notificationIdsShown.add(newdata[0].id);
                const contentsd = (
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={iconWrapper}><CalendarIcon /></div>
                        <div style={{
                            lineHeight: 1.4,
                            cursor: "pointer",
                        }}>
                            <div style={{ fontSize: 14, color: "#333", fontWeight: 500 }}>
                                You have received a new meeting
                            </div>
                            <div role="button"
                                tabIndex={0}
                                onClick={() => {
                                    DetailsOpen(true, newdata[0].id)
                                    NotifcationUI.destroy()
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        DetailsOpen(true, newdata[0].id)
                                    }
                                }}
                                className='splTxt'
                                style={{
                                    marginTop: 2,
                                }}
                            >
                                {newdata[0].title}
                            </div>
                        </div>
                    </div>
                );
                NotifcationUI.open({
                    message: null,
                    description: contentsd,
                    placement: "bottomRight",
                    duration: 5,
                    style: {
                        borderRadius: 10,
                        boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
                        padding: "10px 14px",
                        width: 360,
                    },
                });
            };
        }
        socket.off("meeting", handleNotification);
        socket.on("meeting", handleNotification);
        const handleConnect = () => {
            socket.emit("join", profile.userId);
        };
        socket.off("connect", handleConnect);
        socket.on("connect", handleConnect);
        return () => {
            socket.off("meeting", handleNotification);
            socket.off("connect", handleConnect);
        };
    }, []);
    return (
        <>
            <div className="notification" title='Calender'>
                {(storeSubcription?.isActive && !edit) ?
                    <Popover
                        placement="bottomLeft"
                        content={content}
                        trigger="click"
                        open={open}
                        onOpenChange={handleOpenChange}
                    >
                        {/* <Badge dot offset={[-8, -5]}> */}
                        <span className="head-example" style={{ cursor: "pointer" }}>
                            <CalendarIcon height={24} width={20} />
                        </span>
                        {/* </Badge> */}
                    </Popover> :
                    <span className="head-example" style={{ cursor: "not-allowed" }}>
                        <CalendarIcon height={24} width={20} />
                    </span>
                }
            </div>
            <Popup modelOpen={modelOpen} setModelOpen={setModelOpen} Meeting={mObject} emailCongifDetail={emailapiValues} page="Calendar" />
        </>
    );
}

export default Calendars;
